"use client";
import React, { useEffect, useState } from "react";
import { Grid } from "@mantine/core";
import JobCard from "../jobs/JobCard";
import JobSmallCard from "../jobs/JobSmallCard";
import { IconAlertCircle } from "@tabler/icons-react";

export default function SingleJobsDetail({ dictionary, setCount, jobsData }) {
  useEffect(() => {
    setCount(jobsData?.count ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobsData]);

  return (
    <>
      <Grid gutter={0}>
        {jobsData?.data.length == 0 && (
          <div className="my-20 mx-auto text-center">
            <IconAlertCircle size={100} className="mx-auto text-primary" />
            <div className=" text-[30px] font-semibold text-center text-greyDark mx-auto">
              {dictionary.noResultsFound}
            </div>
            <p className="text-textGrey">
              {dictionary.noResultsFoundCheckFilters}
            </p>
          </div>
        )}
        {jobsData?.data.map((job, index) => (
          <Grid.Col span={12} md={6} lg={12} p={0} key={job.id}>
            <div className="hidden lg:block">
              <JobCard className="my-2" job={job} dictionary={dictionary} />
            </div>
            <div className="block lg:hidden">
              <JobSmallCard className="m-2" job={job} dictionary={dictionary} />
            </div>
          </Grid.Col>
        ))}
      </Grid>
    </>
  );
}
